module.exports = __webpack_public_path__ + "media/34.41b59f91.mp3";